import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { postData } from "../../Services/postData";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { IVideoCallToken } from "../../Utils/Types";
import useJitsiMeet from "../../Hooks/useJitsiMeet";

interface IVideoCallRoomProps {
  roomName: string;
  displayName?: string;
  onCallEnded?: () => void;
}

export default function VideoCallRoom({
  roomName,
  displayName,
  onCallEnded,
}: IVideoCallRoomProps) {
  const [callData, setCallData] = useState<IVideoCallToken | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!roomName) return;
    setLoading(true);
    setErrorMsg(null);
    postData(endpoints.videoCall.generateToken, { room_name: roomName })
      .then((res: any) => {
        setCallData(res.data);
      })
      .catch((err: any) => {
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          Vocabulary.videoCallError;
        setErrorMsg(msg);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [roomName]);

  useJitsiMeet({
    domain: callData?.jitsi_domain ?? "",
    roomName: callData?.room_name ?? "",
    jwt: callData?.token ?? "",
    parentNodeId: "jitsi-container",
    displayName,
    onReadyToClose: onCallEnded,
  });

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography>{Vocabulary.videoCallLoading}</Typography>
      </Box>
    );
  }

  if (errorMsg) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
          gap: 2,
        }}
      >
        <Typography color="error">{errorMsg}</Typography>
        {onCallEnded && (
          <Button variant="contained" onClick={onCallEnded}>
            {Vocabulary.endVideoCall}
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box id="jitsi-container" sx={{ width: "100%", height: "80vh" }} />
  );
}
